import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'working_hour_records_each_worker_are_not_maintained'

export const dataPointDefinition = {
  retracedId: 'working_hour_records_each_worker_are_not_maintained',
  name: 'Working hour records for each worker are not maintained for at least the last 12 months',
  description:
    '"Maintained" refers to keeping physical working hour record documents on-site at the facility in an orderly fashion that is easily accessible.',
  meta: {
    slcpMeta: {
      key: 'wh-wor-22x',
      number: 'WH-WOR-4-1',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wh-wor-22x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36510,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
